var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobPayLess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7868 41.5806C60.4381 45.0219 65.0178 50.9989 63.8013 55.2734C62.5848 59.5841 55.5721 62.2647 49.919 63.3514C44.2301 64.4744 39.865 64.0397 33.711 62.8081C27.557 61.5402 19.6498 59.4754 17.0379 54.3316C14.3902 49.1877 17.0737 40.9648 22.0827 37.4148C27.0561 33.8648 34.3908 34.9877 40.4017 36.0382C46.4484 37.0888 51.1355 38.103 55.7868 41.5806Z",
    fill: "#FA7B6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0315 22.9275C10.8986 22.9276 10.765 22.9276 10.631 22.9276L10.631 21.1276C10.8006 21.1276 10.9697 21.1275 11.1384 21.1274C17.3119 21.1239 22.8865 21.1207 29.0717 25.8502C33.178 28.9902 34.5972 31.61 35.8383 34.2185C35.9249 34.4005 36.0104 34.5819 36.0958 34.7631C37.1971 37.0991 38.2806 39.3974 41.3138 42.2451C43.2658 44.0778 45.5792 44.87 47.9716 45.1979C49.8287 45.4525 51.666 45.423 53.413 45.395C53.9516 45.3864 54.4815 45.3779 55.0009 45.3779L55.0009 47.1779C54.5375 47.1779 54.0453 47.1859 53.531 47.1943C51.763 47.2233 49.7348 47.2564 47.7271 46.9812C45.0982 46.6209 42.3902 45.7248 40.0818 43.5574C36.7958 40.4723 35.5903 37.9137 34.4713 35.5385C34.3849 35.3552 34.2991 35.1731 34.2129 34.9919C33.0477 32.5429 31.7845 30.1906 27.9783 27.2801C22.2814 22.9239 17.2505 22.9255 11.0315 22.9275Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4025 26.8653C11.8992 26.8652 11.3877 26.8651 10.8659 26.8602L10.8828 25.0603C11.3921 25.0651 11.8994 25.0644 12.4055 25.0638C16.9121 25.0579 21.3327 25.0522 26.3327 28.8756C29.9903 31.6724 31.491 34.3932 32.8715 37.0584C32.9328 37.1767 32.9938 37.2948 33.0548 37.4128C34.3468 39.9139 35.6 42.3398 38.5548 44.9505C41.1951 47.2834 43.4189 48.3381 45.647 48.8306C47.6706 49.2779 49.7223 49.2724 52.2186 49.2657C52.5298 49.2648 52.8479 49.264 53.1737 49.264M53.1749 49.264L54.6953 49.2619L54.6977 51.0619L53.1761 51.064H53.1749C52.8524 51.064 52.5335 51.065 52.2179 51.066C49.7529 51.0741 47.4898 51.0814 45.2585 50.5882C42.6935 50.0212 40.2004 48.8064 37.363 46.2994C34.1521 43.4625 32.7669 40.7793 31.4685 38.2641C31.4033 38.1377 31.3382 38.0118 31.2732 37.8863C29.9338 35.3005 28.5812 32.8608 25.2394 30.3055C20.7421 26.8666 16.904 26.866 12.4025 26.8653",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5527 54.9989L53.5527 45.3755L55.3527 45.3755L55.3527 54.9989L53.5527 54.9989Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4493 54.9943L11.118 54.9943L11.118 53.1943L54.4493 53.1943L54.4493 54.9943Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2788 54.9991L10.2788 21.1164L12.0788 21.1164L12.0788 54.9991L10.2788 54.9991Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.234 54.3971L21.234 27.4727L23.034 27.4727L23.034 54.3971L21.234 54.3971Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1892 54.3968L32.1892 39.5733L33.9892 39.5733L33.9892 54.3968L32.1892 54.3968Z",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.145 54.3971L43.145 48.9517L44.945 48.9517L44.945 54.3971L43.145 54.3971Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9878 13.2023L31.1935 18.1978C33.8506 19.4984 34.9395 22.7031 33.6255 25.3559L32.8174 24.9603L32.4178 25.7671L18.2091 18.8123L20.9878 13.2023ZM32.3059 23.7076C32.627 22.1614 31.8797 20.5383 30.3943 19.8113L21.8048 15.6069L20.6245 17.9898L32.3059 23.7076Z",
    fill: "#1C1C1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2249 18.7974L19.895 19.4634C19.5707 20.1182 19.8397 20.9168 20.5071 21.2434C21.1744 21.5701 21.9752 21.2951 22.2995 20.6404L22.6294 19.9743L24.2456 20.7654L23.9157 21.4315C23.1467 22.984 21.2611 23.6172 19.7079 22.857C18.1546 22.0967 17.5098 20.2249 18.2788 18.6724L18.6087 18.0063L20.2249 18.7974Z",
    fill: "#1C1C1C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6057 23.3876L29.2758 24.0537C28.9515 24.7084 29.2206 25.507 29.8879 25.8337C30.5552 26.1603 31.356 25.8853 31.6803 25.2306L32.0103 24.5645L33.6255 25.3559L33.2965 26.0217C32.5275 27.5742 30.6419 28.2075 29.0887 27.4472C27.5354 26.6869 26.8906 24.8151 27.6596 23.2626L27.9895 22.5965L29.6057 23.3876Z",
    fill: "#1C1C1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9265 12.7657C27.0741 12.3485 26.0494 12.6991 25.634 13.5378C25.2186 14.3764 25.5638 15.3976 26.4162 15.8148C27.2686 16.232 28.2932 15.8814 28.7086 15.0427C29.124 14.2041 28.7788 13.1829 27.9265 12.7657ZM24.0178 12.7467C24.8779 11.0102 26.9874 10.3013 28.7257 11.1522C30.4639 12.003 31.1849 14.0974 30.3248 15.8338C29.4647 17.5703 27.3553 18.2792 25.617 17.4283C23.8787 16.5775 23.1577 14.4831 24.0178 12.7467Z",
    fill: "#1C1C1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2627 14.1292L10.6495 10.5002L11.4291 8.87598L19.0423 12.505L18.2627 14.1292Z",
    fill: "#1C1C1C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8095 17.246L10.6495 14.3097L11.4292 12.6858L17.5893 15.6222L16.8095 17.246Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobPayLess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlobPayLess.1513e35d615ab4862a694e4f9d880565.svg";